<template>
    <div>
        <div class="titlePage">Insignias Digitales - Ibero</div>
        <va-notification color="info" v-if="noData" class="refNoData">No se presentan insignias a generar.</va-notification>
        <va-notification color="success" v-if="successBadge" class="refNoData">Se crearon las insignias digitales con éxito</va-notification>
        <va-notification color="danger" v-if="failedBadge" class="refNoData">Se presentó error en proceso de generación de insignias, por favor contactar a departamento de TI.</va-notification>

        <ValidationObserver ref="obsFieldsSearch">
            <FormSearchGrade :FieldsForm="formSearch" :ModelForm="formSchModel" :method="executeProcess" />
        </ValidationObserver>
        <div class="listGrades">
            <DataTableBadges
                :InfoView="this.DLBadges"
                :HeadTable="this.HDBadges"
                v-if="renderComponent1"
            />
        </div>
    </div>
</template>
<script>
import IberoHelpers from '@/store/helpers.js'
import XLSX from 'xlsx'
import FormSearchGrade from '@/components/forms/Forms.vue'
import DataTableBadges from '@/components/data-tables/DataBadge.vue'

export default {
  name: 'DataBadges',
  components: {
    FormSearchGrade,
    DataTableBadges,
  },
  data () {
    return {
      formSchModel: {},
      formSearch: [
        {
          id: 'Sch_Button',
          type: 'button',
          placeholder: 'Generar Insignias',
          class: 'col-md-3',
          disabled: false,
        },
        {
          id: 'Sch_ButtonNew',
          type: 'button',
          placeholder: 'Generar Reporte Excel',
          class: 'col-md-3',
          disabled: false,
        },
      ],
      HDBadges: [
        {
          name: 'numeroDocumento',
          title: 'No Documento',
          sortField: 'numeroDocumento',
          width: '10%',
        },
        {
          name: 'nombres',
          title: 'Nombres',
          sortField: 'nombres',
          width: '15%',
        },
        {
          name: 'apellidos',
          title: 'Apellidos',
          sortField: 'apellidos',
          width: '15%',
        },
        {
          name: 'correo',
          title: 'Correo',
          sortField: 'correo',
          width: '20%',
        },
        {
          name: 'facultad',
          title: 'Facultad',
          sortField: 'facultad',
          width: '20%',
        },
        {
          name: 'ruta',
          title: 'Ruta Formativa',
          sortField: 'ruta',
          width: '20%',
        },
      ],
      DLBadges: [],
      renderComponent1: false,
      noData: false,
      successBadge: false,
      failedBadge: false,
      dataStudents: [],
    }
  },
  methods: {
    executeProcess: function (event, refer) {
      switch (event.target.id) {
        case 'btn_Sch_Button':
          this.generateBadge()
          break
        case 'btn_Sch_ButtonNew':
          this.exportExcel()
          break
      }
    },
    generateBadge () {
      if (this.dataStudents.length >= 1) {
        let loader = this.$loading.show()

        try {
          const token = IberoHelpers.getToken(this.$store)
          token.then(tokenData => {
            for (const student of this.dataStudents) {
              var sendBadge = IberoHelpers.sendBadges(this.$store, student, tokenData)
              console.log(sendBadge)
            }
          })
          this.successBadge = true
        } catch (error) {
          this.failedBadge = true
        } finally {
          loader.hide()
        }
      }
    },
    exportExcel: function () {
      if (this.dataStudents.length >= 1) {
        let loader = this.$loading.show()
        var dateRef = new Date()
        var month = '' + (dateRef.getMonth() + 1)
        var day = '' + dateRef.getDate()
        if (month.length < 2) { month = '0' + month }
        if (day.length < 2) { day = '0' + day }
        const filename = 'ListadoInsignias_' + day + month + dateRef.getFullYear()

        let data = XLSX.utils.json_to_sheet(this.dataStudents)
        const workbook = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(workbook, data, filename)
        XLSX.writeFile(workbook, `${filename}.xlsx`)
        loader.hide()
      }
    },
  },
  mounted: async function () {
    const token = IberoHelpers.getToken(this.$store)
    token.then(tokenData => {
      let loader = this.$loading.show()
      this.renderComponent1 = false
      var studentsList = IberoHelpers.getStudentsList(this.$store, tokenData)
      studentsList.then(response => {
        if ((response.data === undefined) || (response.data === '')) {
          this.noData = true
        } else {
          if (Array.isArray(response.data)) {
            this.dataStudents = response.data
            this.DLBadges = response.data
          } else {
            this.DLBadges = [response.data]
          }
          IberoHelpers.forceRerender1(this)
        }
        loader.hide()
      })
    })
  },
}
</script>